<template lang="">
    <div class="row m-auto justify-content-center">
        <div class="col-md-5 border">
            <h2 class="my-4 text-center">Informations personnelles</h2>
            <b-form>
            <div>
                                <b-form-group
                                    label-cols="6" 
                                        label-cols-lg="4" 
                                        id="lastName-group"
                                        :label="$t('message.lastName')"
                                        label-for="lastName"
                                        description="">
                                    <b-form-input
                                        id="lastName"
                                        v-model="user.nom"
                                        :state="user.nom.$dirty ? !(errorshasField('nom') || user.nom) : null"
                                        type="text"
                                        required
                                        placeholder=""
                                        
                                        @focus="clearErrorField('nom')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!user.nom.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('nom')">
                                        {{ getErrorsField('nom') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group
                                    label-cols="6" 
                                        label-cols-lg="4" 
                                        id="firstName-group"
                                        :label="$t('message.firstName')"
                                        label-for="firstName"
                                        description="">
                                    <b-form-input
                                        id="lastName"
                                        v-model="user.prenom"
                                        :state="user.prenom.$dirty ? !(errorshasField('prenom') || $v.form.user.prenom.$error) : null"
                                        type="text"
                                        required
                                        
                                        @focus="clearErrorField('prenom')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!user.prenom.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('prenom')">
                                        {{ getErrorsField('prenom') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group
                                v-if="user.souscripteur"
                                    label-cols="6" 
                                    label-cols-lg="4" 
                                    label-size="lg" 
                                    id="sexe-group"
                                    :label="$t('message.gender')"
                                    label-for="gender">
                                    <b-form-select
                                        id="gender"
                                        v-model="user.souscripteur.sexe"
                                        :options="sexes"
                                        required
                                        
                                        @focus="clearErrorField('sexe')"
                                    ></b-form-select>

                                    <b-form-invalid-feedback v-if="!user.sexe">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('sexe')">
                                        {{ getErrorsField('sexe') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group
                                    label-cols="6" 
                                        label-cols-lg="4" 
                                        id="telephone-group"
                                        label="Tel"
                                        label-for="telephone">
                                    <b-form-input
                                        id="telephone"
                                        v-model="user.telephone"
                                        :state="user.telephone.$dirty ? !(errorshasField('telephone') || $v.form.user.telephone.$error) : null"
                                        required
                                        
                                        @focus="clearErrorField('telephone')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!user.telephone.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="!user.telephone.integer">
                                        {{ $t('message.integer', { n: 9 }) }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="!user.telephone.minLength">
                                        {{ $t('message.minCharacters', { n: 9 }) }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('telephone')">
                                        {{ getErrorsField('telephone') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                                
                                <b-form-group
                                    label-cols="6" 
                                        label-cols-lg="4" 
                                        id="single-group"
                                        :label="$tc('message.countries', 1)"
                                        label-for="single">
                                    <!-- Options -->
                                    <b-form-input
                                        id="gender"
                                        v-model="user.pays"
                                        required
                                        
                                        @focus="clearErrorField('sexe')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('pays')">
                                        {{ getErrorsField('pays') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.user.pays.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>
                                
                                <b-form-group
                                    label-cols="6" 
                                        label-cols-lg="4" 
                                        id="ville-group"
                                        :label="$tc('message.cities', 1)"
                                        label-for="ville">
                                    <b-form-input
                                            id="ville"
                                            v-model="user.ville"
                                            required
                                            
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('ville')">
                                        {{ getErrorsField('ville') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.user.ville.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group
                                    label-cols="6" 
                                        label-cols-lg="4" 
                                        id="quartier-group"
                                        :label="$t('message.street')"
                                        label-for="quartier">
                                    <b-form-input
                                            id="quartier"
                                            v-model="user.quartier"
                                            :state="user.quartier ? !(errorshasField('quartier') || user.quartier.$error) : null"
                                            @focus="clearErrorField('quartier')"
                                            required
                                            
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('quartier')">
                                        {{ getErrorsField('quartier') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.user.quartier.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group
                                    label-cols="6" 
                                        label-cols-lg="4" 
                                        id="code_postal-group"
                                        :label="$t('message.zipCode')"
                                        label-for="code_postal">
                                    <b-form-input
                                            id="code_postal"
                                            v-model="user.code_postal"
                                            :state="$v.form.user.code_postal.$dirty ? !(errorshasField('code_postal') || $v.form.user.code_postal.$error) : null"
                                            @focus="clearErrorField('code_postal')"
                                            required
                                            
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('code_postal')">
                                        {{ getErrorsField('code_postal') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.user.code_postal.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group
                                    label-cols="6" 
                                        label-cols-lg="4" 
                                        id="adresse-group"
                                        :label="$t('message.address')"
                                        label-for="adresse">
                                    <b-form-input
                                            id="adresse"
                                            v-model="user.adresse"
                                            :state="$v.form.user.adresse.$dirty ? !(errorshasField('adresse') || $v.form.user.adresse.$error) : null"
                                            @focus="clearErrorField('adresse')"
                                            required
                                            
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('adresse')">
                                        {{ getErrorsField('adresse') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.user.adresse.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </div>
            <div class="form-group d-flex justify-content-between align-items-center">
                <button type="submit" class="btn btn-default" @click="onSubmit">Modifier </button>
                <router-link to="/setting" class="btn btn-primary">Modifier mot de passe</router-link>
            </div>
        </b-form>
        </div>
    
    </div>

</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
//import SlimSelect from 'slim-select';
import moment from "moment";
import { required, email, integer, minLength } from 'vuelidate/lib/validators';
import Swal from 'sweetalert2';
import AppConfig from '../constants/AppConfig';

export default {
    name: "UserInfo",
    components: {

    },
    data: () => ({
        moment: moment
    }),
    computed: {
        ...mapGetters(["subscriber", 'hasAdminRole', "countries",
            'hasGestionnaireRole', 'hasSouscripteurRole', 'hasMedecinControleRole', 'hasPraticienRole', 'hasAssistante',
            "patients", "commandes"]),

        mCountries: function () {
            let cArray = [];

            _.forOwn(this.countries, function (value, key) {
                cArray.push({ text: value.name, value: value.name });
            });

            return cArray;
        },

        can: function () {
            return this.hasAdminRole || this.hasGestionnaireRole;
        },

    },

    data() {
        return {
            roles: [],
            information: {},
            user: JSON.parse(localStorage.getItem("user")),
            mobileView: true,
            option: {
                penColor: "rgb(0, 0, 0)",
                backgroundColor: "rgb(255,255,255)"
            },
            disabled: JSON.parse(localStorage.getItem('user'))['signature'] == null ? true : false,
            dataUrl: JSON.parse(localStorage.getItem('user'))['signature'],
            consentement: 1,
            // form: this.subscriber != null ? this.subscriber : {user: JSON.parse(localStorage.getItem('user')), sexe: JSON.parse(localStorage.getItem('user'))['souscripteur']['sexe']},
            sexes: [
                { value: 'F', text: this.$i18n.t('message.female') },
                { value: 'M', text: this.$i18n.t('message.male') },
            ],
            subscriber_id: JSON.parse(localStorage.getItem('user'))['slug'],
            signature: JSON.parse(localStorage.getItem('user'))['signature'],
            paginationOptions: {
                enabled: true,
                mode: 'records',
                perPageDropdown: [3, 6, 10]
            },

            enabled: { enabled: true },

            sort: {
                enabled: true,
                initialSortBy: { field: 'date', type: 'desc' }
            },
            affiliateColumns: [
                {
                    label: this.$i18n.tc('message.patients', 1),
                    field: 'type_contrat.description_fr',
                },
                {
                    field: 'nombre_restant',
                    label: this.$i18n.t('message.fileNumber')
                },
                {
                    field: 'type_contrat.montant',
                    label: this.$i18n.t('message.old')
                },
                {
                    field: 'created_at',
                    label: this.$i18n.t('message.email')
                },
            ],
        }
    },

    methods: {
        handleView() {
            this.mobileView = window.innerWidth <= 990;
        },
        getUserInfo: function () {
            let roles = [];
            fetch(AppConfig.apiUrl + '/user-show/' + this.user.slug, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'Authorization': 'Bearer ' + localStorage.getItem('ms-token')
                },
            })
                .then(function (response) {
                    return response.json();
                }).then(
                    res => {
                        this.information = res.user;
                        if (this.information) {
                            this.information.roles.forEach(i => {
                                roles.push({
                                    name: i.name,
                                })
                            })
                        }
                        this.roles = roles;
                    }
                ).catch(error => { })
        },
        onSubmit: function (evt) {
            evt.preventDefault();

                let data = {
                    slug: this.user.slug,
                    sexe: this.user.sexe,
                    nom: this.user.nom,
                    prenom: this.user.prenom,
                    telephone: this.user.telephone,
                    ville: this.user.ville,
                    pays: this.user.pays,
                    adresse: this.user.adresse,
                    quartier: this.user.quartier,
                    code_postal: this.user.code_postal
                };

                let successMessage = this.$i18n.t('message.subscriberUpdated');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };
                fetch(AppConfig.apiUrl+'/update-user/'+this.user.slug, {
                  headers: 
                    {
                        'Authorization': "Bearer " + localStorage.getItem('ms-token'),
                        'Content-Type': 'application/json',
                    },
                        method: 'PUT',
                        body: JSON.stringify(data)})
                    .then(res => res.json())
                    .then(res => {
                        if(res.error != null){
                            Swal.fire({
                                title: "Erreur",
                                icon: 'error',
                            })
                        }else{
                            Swal.fire({
                                title: "Opération réussie",
                                text: "Les informations ont été modifier avec succès",
                                icon: 'success',
                            })
                        }

                    }).catch(error => {
                        // console.log('error ', error);
                }) 

        },

        getValue(item) {
            if (typeof item != "undefined") {
                return item;
            } else {
                return "";
            }
        },
        getCountries: function () {
            let args = {};
            let errorMessages = {
                generic: this.$i18n.t('message.genericError'),
                error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
            };

            this.$store.dispatch('getCountries', { args, errorMessages });
        },
        getErrorsField(field) {
            if (this.errorshasField(field)) {
                return this.errors[field][0];
            } else {
                return '';
            }
        },
        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },

        clearErrorField(field) {
            this.$store.dispatch('clearErrorField', { field });

            this.getErrorsField(field);
        },
        /**
         * signature
         */

        clear() {
            var _this = this;
            this.disabled = true;
            _this.$refs.signature.clear();
        },
        undo() {
            var _this = this;
            _this.$refs.signature.undo();
        }
    },

    validations: {
        form: {
            user: {
                nom: {
                    required
                },
                prenom: {
                    required
                },
                adresse: {
                    // required
                },
                telephone: {
                    required,
                    integer,
                    minLength: minLength(9)
                },
                email: {
                    required,
                    email
                },
                nationalite: {
                },
                ville: {
                    required
                },
                pays: {
                    required
                },

                quartier: {

                },

                code_postal: {

                },
                adresse: {

                }
            },
            sexe: {
                required
            },
            date_de_naissance: {
                // required
            }
        }
    },
    created() {
        this.handleView();
        // this.getUserInfo();
        window.addEventListener('resize', this.handleView);
    },
    mounted() {
        this.getCountries();
        this.getUserInfo();
    }
}
</script>
<style lang="">
    
</style>